var _path, _g, _path2, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEfficientManage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.51672 2.85886L7.93295 1.67554C9.54228 1.24432 10.7081 1.94779 11.1563 3.62062L12.3851 8.20671C12.8334 9.87954 12.1755 11.0716 10.5662 11.5029L6.14995 12.6862C4.54061 13.1174 3.37904 12.4128 2.9308 10.74L1.70197 6.1539C1.25373 4.48107 1.90739 3.29009 3.51672 2.85886Z",
    fill: "url(#paint0_linear_9308_7469)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9308_7469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.06969 4.35761L8.4064 3.46354C9.62235 3.13772 10.4936 3.63348 10.8153 4.83429L11.6974 8.12632C12.0192 9.32712 11.5126 10.1921 10.2966 10.5179L6.95989 11.412C5.74395 11.7378 4.87589 11.2412 4.55413 10.0404L3.67204 6.74833C3.35028 5.54752 3.85374 4.68342 5.06969 4.35761Z",
    fill: "#8237FF",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 0.294676,
    y: -0.458254,
    width: 20.7878,
    height: 20.7878
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2.06px)",
      clipPath: "url(#bgblur_0_9308_7469_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4.12671,
    d: "M13.5288 3.75439C14.5809 3.75439 15.4196 4.05182 15.9946 4.62451C16.5696 5.19725 16.8696 6.03417 16.8696 7.08936V12.7817C16.8696 13.831 16.571 14.6685 15.9976 15.2427C15.4241 15.8168 14.5869 16.1167 13.5347 16.1167H7.84229C6.78695 16.1167 5.95018 15.816 5.37744 15.2417C4.80486 14.6674 4.50732 13.8308 4.50732 12.7817V7.08936C4.50732 6.03426 4.8046 5.19735 5.37744 4.62451C5.95028 4.05167 6.78719 3.75439 7.84229 3.75439H13.5288Z",
    fill: "#8237FF",
    fillOpacity: 0.15,
    stroke: "url(#paint1_linear_9308_7469)",
    strokeWidth: 0.171946,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 5.36661,
    y: 4.61905,
    width: 10.6381,
    height: 10.632
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.29px)",
      clipPath: "url(#bgblur_1_9308_7469_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9308_7469)",
    "data-figma-bg-blur-radius": 2.57919
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9196 10.441H11.1885V12.1659C11.1885 12.4463 10.963 12.6718 10.6826 12.6718C10.4022 12.6718 10.1767 12.4463 10.1767 12.1659V10.441H8.45171C8.17133 10.4349 7.9458 10.2093 7.9458 9.92895C7.9458 9.79424 8.00066 9.66685 8.09209 9.56932C8.18961 9.47789 8.31762 9.42304 8.45171 9.42304H10.1767V7.70415C10.1767 7.42377 10.4022 7.19824 10.6826 7.19824C10.963 7.19824 11.1885 7.42377 11.1885 7.70415V9.42304H12.9196C13.2 9.42304 13.4255 9.64856 13.4255 9.92895C13.4255 10.2093 13.2 10.4349 12.9196 10.441Z",
    fill: "url(#paint2_linear_9308_7469)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6821 7.21582C10.953 7.21582 11.1714 7.43324 11.1714 7.7041V9.44043H12.9194C13.1902 9.44043 13.4086 9.65793 13.4087 9.92871C13.4087 10.1995 13.1906 10.4178 12.9194 10.4238H11.1714V12.166C11.1713 12.4369 10.953 12.6543 10.6821 12.6543C10.4115 12.654 10.1939 12.4367 10.1938 12.166V10.4238H8.45166C8.1806 10.4177 7.96338 10.1994 7.96338 9.92871C7.96344 9.7992 8.01582 9.67648 8.104 9.58203C8.1986 9.49335 8.32231 9.44044 8.45166 9.44043H10.1938V7.7041C10.1939 7.43339 10.4115 7.21607 10.6821 7.21582Z",
    stroke: "url(#paint3_linear_9308_7469)",
    strokeOpacity: 0.5,
    strokeWidth: 0.0343893
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9308_7469",
    x: 0.826008,
    y: 0.614582,
    width: 13.7171,
    height: 13.6463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.37557,
    result: "effect1_foregroundBlur_9308_7469"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_9308_7469_clip_path",
    transform: "translate(-0.294676 0.458254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5288 3.75439C14.5809 3.75439 15.4196 4.05182 15.9946 4.62451C16.5696 5.19725 16.8696 6.03417 16.8696 7.08936V12.7817C16.8696 13.831 16.571 14.6685 15.9976 15.2427C15.4241 15.8168 14.5869 16.1167 13.5347 16.1167H7.84229C6.78695 16.1167 5.95018 15.816 5.37744 15.2417C4.80486 14.6674 4.50732 13.8308 4.50732 12.7817V7.08936C4.50732 6.03426 4.8046 5.19735 5.37744 4.62451C5.95028 4.05167 6.78719 3.75439 7.84229 3.75439H13.5288Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9308_7469",
    x: 5.36661,
    y: 4.61905,
    width: 10.6381,
    height: 10.632,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.859731,
    dy: 0.859731
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.859731
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.509804 0 0 0 0 0.215686 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9308_7469"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9308_7469",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_9308_7469_clip_path",
    transform: "translate(-5.36661 -4.61905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9196 10.441H11.1885V12.1659C11.1885 12.4463 10.963 12.6718 10.6826 12.6718C10.4022 12.6718 10.1767 12.4463 10.1767 12.1659V10.441H8.45171C8.17133 10.4349 7.9458 10.2093 7.9458 9.92895C7.9458 9.79424 8.00066 9.66685 8.09209 9.56932C8.18961 9.47789 8.31762 9.42304 8.45171 9.42304H10.1767V7.70415C10.1767 7.42377 10.4022 7.19824 10.6826 7.19824C10.963 7.19824 11.1885 7.42377 11.1885 7.70415V9.42304H12.9196C13.2 9.42304 13.4255 9.64856 13.4255 9.92895C13.4255 10.2093 13.2 10.4349 12.9196 10.441Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9308_7469",
    x1: 0.999773,
    y1: 3.53328,
    x2: 10.0657,
    y2: 9.50447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8237FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8237FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9308_7469",
    x1: 6.53381,
    y1: 5.26056,
    x2: 14.3102,
    y2: 14.8917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9308_7469",
    x1: 13.037,
    y1: 8.18666,
    x2: 6.93314,
    y2: 8.3859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9308_7469",
    x1: 8.53608,
    y1: 9.03437,
    x2: 13.1891,
    y2: 9.06009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEfficientManage);
export default __webpack_public_path__ + "static/media/efficientManage.7e8a97fb596b98662ad57bed1f610076.svg";
export { ForwardRef as ReactComponent };